import posthog from "posthog-js";
import type { CaptureResult } from "posthog-js";

const BLOCKED_AUTOMATIC_EVENTS = new Set(["$pageview", "$pageleave", "$dead_click", "$web_vitals"]);

let isInitialized = false;
let isUserIdentified = false;

const shouldSendEvent = (event: CaptureResult | null): CaptureResult | null => {
  if (!event || BLOCKED_AUTOMATIC_EVENTS.has(event.event)) {
    return null;
  }
  return event;
};

type InitPosthogOptions = {
  apiKey: string;
};

type PosthogPersonProperties = {
  full_name?: string;
  user_id?: number;
  company_id?: number;
  preferred_timezone?: string;
  user_role?: string;
  user_type?: string;
  email?: string;
  company_name?: string;
};

export const initPosthog = ({ apiKey }: InitPosthogOptions): void => {
  if (isInitialized) return;

  posthog.init(apiKey, {
    api_host: "https://posthog.cargobase.com",
    capture_pageview: false,
    capture_pageleave: false,
    autocapture: false,
    capture_dead_clicks: false,
    capture_performance: false,
    rageclick: false,
    enable_heatmaps: false,
    disable_scroll_properties: true,
    disable_session_recording: true,
    before_send: shouldSendEvent,
  });

  isInitialized = true;
};

export const identifyPosthogUser = (email: string, companyId: number, personProperties: PosthogPersonProperties): void => {
  if (!isInitialized || isUserIdentified) return;

  posthog.identify(email, {
    ...personProperties,
    email,
  });
  posthog.group("company", `id:${companyId}`);
  isUserIdentified = true;
};

export const isPosthogInitialized = (): boolean => isInitialized;
